import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'salaryP3K'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const pangkatP3KList = 'Master/RankP3K/list/'
export const salaryP3KCreate = 'Master/SalaryP3K/create/'
export const salaryP3KList = 'Master/SalaryP3K/list/'
export const salaryP3KDetail = 'Master/SalaryP3K/detail/'
export const salaryP3KUpdate = 'Master/SalaryP3K/update/'
export const salaryP3KInactive = 'Master/SalaryP3K/inactive/'
export const salaryP3KActive = 'Master/SalaryP3K/active/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}